<template>
    <div class="taxation-banner-container">
        <div class="taxation-banner -wrap">
            <div class="taxation-banner__left-container">
                <h2 class="taxation-banner__title" v-html="$t('TaxationDayBanner.title')"></h2>
                <p class="taxation-banner__description" v-html="$t('TaxationDayBanner.description')"></p>
            </div>
            <div class="taxation-banner__right-container">
                <div class="taxation-banner__portraits">
                    <template v-for="(image, index) in getImageArrayWithCountryCode">
                        <img :key="index" :src="getImagePath(image)" alt="" class="taxation-banner__circular-portrait"/>
                        <div v-if="getIndex(index) === 3 && getImageArrayWithCountryCode.length > 5" :key="image" class="taxation-banner__circular-portrait-break"></div>
                    </template>
                </div>
                <div class="taxation-banner__buttons">
                    <TotemButton
                        class="taxation-banner__register-button"
                        color="secondary"
                        @click="openRegisterPage($t('TaxationDayBanner.link'))"
                        :label="$t('TaxationDayBanner.button')"
                    />
                    <span class="icon-cancel taxation-banner__close-button" @click="closeBanner"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import config from 'services/config'
    import importAllImages from 'components/shared/mixins/importAllImages'

    export default {
        name: 'taxation-day-banner',
        data () {
            return {
                images_fi: [],
                images_se: []
            }
        },
        mixins: [importAllImages],
        computed: {
            getImageArrayWithCountryCode () {
                switch (config.appLanguage) {
                case 'fi': return this.images_fi
                case 'se': return this.images_se
                }
                return false
            }
        },
        methods: {
            closeBanner () {
                window.localStorage.setItem('showTaxationDayBanner2023', false)
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            },
            getImagePath (image) {
                return require('@/assets/images/skattedag/' + config.appLanguage + '/' + image)
            },
            getIndex (index) {
                return +index
            },
            openRegisterPage(url) {
                window.open(url, '_blank')
            }
        },
        created () {
            this.images_se = this.importAll(require.context('@/assets/images/skattedag/se/', false, /\.(png|jpe?g|svg)$/))
            this.images_fi = this.importAll(require.context('@/assets/images/skattedag/fi/', false, /\.(png|jpe?g|svg)$/))
        }
    }
</script>

<style lang="scss" scoped>
    .taxation-banner-container {
        margin: 30px 0px 0px 0px;
    }
    .taxation-banner {
        background: $champagne;
        color: $black;
        border-radius: 10px;
        font-family: 'Quicksand-Regular';
        padding: 20px 30px;
        display: flex;

        [class*="mobile"] &, [class*="desktop_l"] & {
            flex-direction: column;
        }

        &__title {
            font-family: 'Quicksand-Regular';
            font-weight: 600;
        }

        &__description {
            margin: 20px 0px 0px;
            font-family: 'Nunito-Regular';
            font-size: 1.8rem;
            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 20px 0px 20px;
            }
        }

        &__right-container {
            flex-direction: row;
            display: flex;
            align-items: center;
            justify-content: center;

            [class*="mobile"] & {
                flex-direction: column;
            }
        }

        &__portraits {
            [class*="mobile"] &, [class*="desktop_l"] & {
                display: flex;
                justify-content: space-between;
            }
        }

        &__circular-portrait {
            margin: 0 5px;

            [class*="mobile"] &, [class*="desktop_l"] & {
                margin: 0 3px;
                width: 20%;
            }

        }

        &__circular-portrait-break {
            width: 100%;
        }

        &__left-container {
            flex-direction: column;
            display: flex;
            flex: 1;
            justify-content: center;
        }

        &__buttons {
            padding: 10px;
            margin: 0 0 0 15px;
            display: flex;
            align-items: center;
            [class*="mobile"] &, [class*="desktop_l"] & {
                padding: 20px;
            }
        }

        &__close-button {
            font-size: 3rem;
            margin: 0 20px;
        }
    }
</style>
